function getClearedTestKey(key){
    let index = key.match("[0-9]{4}-[0-9]{2}-[0-9]{2}").index;
    let clearedTestKey = `${key.slice(0, index - 1)}Y${key.slice(index)}`;
    return clearedTestKey;
}

export{
    getClearedTestKey
}